import {Component, NgModule} from '@angular/core';
import {UserService} from '../../../../user/src/lib/user.service';
import {EMPTY_PATH, SETTINGS_PATH, USER_PROFILE_PATH} from 'shared/magic';
import {CommonModule} from '@angular/common';
import {TranslocoModule} from '@ngneat/transloco';
import {RouterModule} from '@angular/router';
import {IconSpritesModule} from 'shared/lib/icon-sprite/icon-sprite.component';

@Component({
	selector: 'shared-user-bar',
	templateUrl: './user-bar.component.html',
	styleUrls: ['./user-bar.component.scss']
})
export class UserBarComponent {
	currentUser = this.user.user;

	SETTINGS_PATH = SETTINGS_PATH;
	EMPTY_PATH = EMPTY_PATH;
	USER_PROFILE_PATH = USER_PROFILE_PATH;
	constructor(private user: UserService) {
	}
}
@NgModule({
	declarations: [UserBarComponent],
	imports: [
		CommonModule,
		TranslocoModule,
		RouterModule,
		IconSpritesModule
	],
	exports: [UserBarComponent]
})
export class UserBarModule {}
